import { render, staticRenderFns } from "./Auteur.vue?vue&type=template&id=b254b562&scoped=true&"
import script from "./Auteur.vue?vue&type=script&lang=js&"
export * from "./Auteur.vue?vue&type=script&lang=js&"
import style0 from "./Auteur.vue?vue&type=style&index=0&id=b254b562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b254b562",
  null
  
)

export default component.exports